import { Close } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material';
import { pluralize } from '@prismamedia/one-components';
import { FC, ReactNode } from 'react';
import {
  ADD_ONE_CONTENT_TITLE,
  CONTENT_WORD,
  SELECTED_WORD,
} from './constants';
import { useStyles } from './styles';

type ItemType<I> = I & { id: string };

interface MultimediaToolbarProps {
  children: ReactNode;
  handleSave: () => void;
  isBusy: boolean;
  onClose?: () => void;
  selectedItems: ItemType<any>[];
  setIsOpen: (open: boolean) => void;
}

export const MultimediaToolbar: FC<MultimediaToolbarProps> = ({
  children,
  handleSave,
  isBusy,
  onClose,
  setIsOpen,
  selectedItems,
}) => {
  const isSelected = selectedItems.length > 0;
  const classes = useStyles({ isSelected });

  const getSelectedItemsTitle = () => {
    const nbItemsSelected = selectedItems.length;
    const contentText = pluralize(CONTENT_WORD, nbItemsSelected);
    const selectText = pluralize(SELECTED_WORD, nbItemsSelected);

    return `${nbItemsSelected} ${contentText} ${selectText}`;
  };

  return (
    <div className={classes.wrapper}>
      {/* Title */}
      <div className={classes.wrapperTitle}>
        {isSelected ? (
          <Accordion classes={{ root: classes.wrapperAccordion }}>
            <AccordionSummary
              aria-controls="selected-content-panel"
              classes={{ root: classes.accordionSummary }}
              expandIcon={<ExpandMoreIcon />}
              id="selected-content-panel"
            >
              <Typography
                variant="h6"
                color="inherit"
                className={classes.title}
              >
                {getSelectedItemsTitle()}
              </Typography>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.accordionDetails }}>
              {children}
            </AccordionDetails>
          </Accordion>
        ) : (
          <Typography variant="h6" color="inherit" className={classes.title}>
            {ADD_ONE_CONTENT_TITLE}
          </Typography>
        )}
      </div>

      <AppBar color="inherit" position="static">
        <Toolbar>
          {/* Left side */}
          <div className={classes.wrapperLeftSide}>
            {isSelected && (
              <IconButton
                aria-label="Close"
                edge="start"
                color="inherit"
                onClick={() => {
                  onClose?.();
                  setIsOpen(false);
                }}
              >
                <Close />
              </IconButton>
            )}
          </div>

          {/* Right side */}
          <div className={classes.wrapperRightSide}>
            {isSelected ? (
              <Button
                className={classes.buttonColor}
                data-testid="add-item"
                disabled={isBusy}
                onClick={() => {
                  handleSave();
                }}
                variant="contained"
              >
                <Typography variant="button" className={classes.whiteText}>
                  Ajouter
                </Typography>
              </Button>
            ) : (
              <IconButton
                aria-label="Close"
                edge="start"
                color="inherit"
                onClick={() => {
                  onClose?.();
                  setIsOpen(false);
                }}
              >
                <Close />
              </IconButton>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};
